<template>
  <div class="card-resource">
    <div class="card-resource-body">
      <div class="d-flex justify-content-between">
        <div class="add-resource">
        <form-side-bar
            :sb-id="formSBId"
            :resource="{}"
            :settings="{}"
        />
        </div>
        <span class="search">
          <label>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                fill="#B3C2CB"
              />
            </svg>
            <input
              type="search"
              class="search-input"
              placeholder="Search Resources"
              v-model="searchStr"
            /> </label
        ></span>
      </div>
      <div class="resources">
        <Table
            :profile="profile"
            :fields="fields"
            :items="resources"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import TimeAgo from "vue2-timeago";
import Table from "./table";
import FormSideBar from "./formSideBar";
import Spreadsheet from "@/components/common/spreadsheet";

export default {
  name: "Admin_Resources",
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    TimeAgo,
    Table,
    Spreadsheet,
    FormSideBar
  },
  computed: {
    ...mapGetters({
      adminData: "admin/adminData"
    }),
    resources(){
      return this.adminData && this.adminData.resources ? this.adminData.resources :[];
    },
    resourcesOld() {
      if (this.searchStr.trim() == "") return this.allTools;
      let filteredResources = [];

      filteredResources = this.allTools.filter(resource => {
        return (
          resource.name &&
          (resource.name
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim()) ||
            resource.name
              .toLowerCase()
              .includes(this.searchStr.toLowerCase().trim()))
        );
      });

      return filteredResources;
    },
    filteredFields() {
      return this.fields && Array.isArray(this.fields)
        ? this.fields.filter(aField => {
            return aField.isAvail;
          })
        : [];
    },
    columns() {
      return this.convertFieldToColumn(this.fields);
    },
    content() {
      return this.convertItemsToContent(this.publishings);
    }
  },
  mounted() {},
  methods: {
    getAdminData() {
      this.$store.dispatch("admin/getAdminData").then((res)=>{
        this.$store.dispatch("user/showNotification", {
          title: "Success",
          description: "Data updated successfully.",
          variant: "success"
        });
      }).catch((rej)=>{
        this.$store.dispatch("user/showNotification", {
          title: "Success",
          description: "Could not update the data.",
          variant: "danger"
        });
      });
    },
    handleOpenFormSideBar() {
      this.formSBModel = true;
    },
    handleCloseFormSideBar() {
      this.formSBModel = false;
    },
    handleActivation() {//Activation of Apps Tab in Admin
      debugger;
      this.getAdminData();
    },
    showDeleteTool(resource) {
      this.selectedMode='del';
      this.selectedResource = resource;
      this.$bvModal.show(this.modalId);
    },
    handleEditToolClick(resource) {
      this.selectedResource = resource;
      this.selectedMode ="edit";
      this.$bvModal.show(this.modalId);
    },
    handleToolUpdated(resource){
      /*@ToDo- Just get an update of this resource*/
      this.getAdminData();
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    getStatus(status) {
      if (status == "active") {
        return "Active";
      } else return "In Active";
    },
    getStatusColor(status) {
      if (status == "active") {
        return "#4BB543";
      } else return "#FF0000";
    },
    formatDate(date) {
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    },
    toggleSphere(e) {
      if (this.formTool.spheres.includes(e)) {
        let index = this.formTool.spheres.indexOf(e);
        this.formTool.spheres.splice(index, 1);
      } else {
        this.formTool.spheres.push(e);
      }
    },
    hideDeleteTool() {
      this.formTool = null;
      this.$bvModal.hide(this.modalId);
    },
    deleteTool() {
      this.$store
        .dispatch("admin/deleteTool", {
          resourceId: this.selectedResource.resourceId,
          deletedBy: this.profile.userId
        })
        .then(res => {
          this.$bvModal.hide(this.modalId);
          this.getAdminData();
        });
    },
  },
  data() {
    return {
      formSBId: "addedit-resource-sidebar",
      fields: [
        { key: "Index", sortable: false, label: "Ind", isAvail: true },
        { key: "title", sortable: true, label: "Title", isAvail: true },
        { key: "imgURL", sortable: false, label: "Cover Image", isAvail: true },
        { key: "docURL", sortable: false, label: "Document", isAvail: true },
        {
          key: "description",
          sortable: true,
          label: "Description",
          isAvail: true
        },
        { key: "price", sortable: true, label: "Price", isAvail: true },
        {
          key: "company.name",
          sortable: true,
          label: "Company",
          isAvail: true
        },
        { key: "status", label: "Status", sortable: false, isAvail: true },
        {
          key: "_created_at",
          label: "Created",
          sortable: false,
          formatter: "formatDate",
          isAvail: true
        },
        {
          key: "_updated_at",
          label: "Updated",
          sortable: false,
          formatter: "formatDate",
          isAvail: true
        },
        { key: "actions", label: "Actions", isAvail: true },
        { key: "show_details", label: "Show Details", isAvail: true }
      ],
      readMore: {},
      modalId: "admin-resources",
      resourceVideo: "resource-video",
      searchStr: "",
      add: true,
      edit: false,
      del: false,
      input: "",
      imgDataUrl: "",
      activeIndex: -1,
      selectedResource: null,
      selectedMode: null,
      statusOptions: [
        //@TODO - Move to Mixin
        { value: null, text: "Please select an option" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" }
      ],
      showUpload: false,
      headers: {
        smail: "*_~"
      },
      transProps: {
        name: "flip-list" // Transition name
      },
      currentPage: 1,
      perPage: 50,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }]
    };
  }
};
</script>

<style lang="scss" scoped>
.add-resource {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-resource {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  .upload-btn {
    margin: 10px;
  }
  input {
    margin-top: 5px;
    margin-bottom: 10px;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-user {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-resource {
  box-shadow: none;
}
.resources {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
}
.actions {
  display: flex;
  justify-content: space-evenly;
}
.status {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  .status-btn {
    display: inline-block;
    margin-right: 15px;
    width: 105px;
    height: 21px;
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    background: var(--theme-color);
    text-align: center;
    border: none;
    border-radius: 3px;
  }
}
.resource-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
#description {
  border-radius: 5px;
}
#resource-video {
  visibility: hidden;
  position: absolute;
}
.inline-form {
  display: flex;
  justify-content: space-around;
}
.resource-images {
  display: flex;
  flex-wrap: wrap;
  .resource-image {
    margin-left: 15px;
    width: 115px;
    height: 170px;
    border-radius: 5px;
  }
}
.companies {
  cursor: pointer;
  padding: 5px 15px;
  border-bottom: 1px solid #000;
  width: 250px;
  span {
    font-weight: bold;
  }
  .company-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 20px;
  }
}
.resource-video {
  width: 250px;
  height: 185px;
  border-radius: 15px;
}
</style>
